(() => {
  // 1) Esto define "qué buscamos": el bloque de comprar
  const SEL = 'product-form, form[action*="/cart/add"]';

  // 2) Aquí guardamos la copia del HTML del botón/form
  let savedHTML = null;

  // 3) Un "marcador" invisible para saber dónde reinsertarlo
  let marker = null;

  // 4) Para evitar que se reinserte en bucle infinito
  let restores = 0;

  // Guarda una copia del form si lo encuentra
  function backup() {
    if (savedHTML) return true;

    const el = document.querySelector(SEL);
    if (!el) return false;

    savedHTML = el.outerHTML;

    // ponemos un comentario invisible justo después del form
    marker = document.createComment('atc-marker');
    el.parentNode.insertBefore(marker, el.nextSibling);

    console.log('[fixes] Copia del ATC guardada ✅');
    return true;
  }

  // Si falta el form, lo restaura
  function restoreIfMissing() {
    if (!savedHTML || !marker) return;

    // si ya existe, no hacemos nada
    if (document.querySelector(SEL)) return;

    // freno por si algo lo borra constantemente
    if (restores >= 3) return;

    const tmp = document.createElement('div');
    tmp.innerHTML = savedHTML;

    const node = tmp.firstElementChild;
    marker.parentNode.insertBefore(node, marker);

    restores++;
    console.warn('[fixes] ATC restaurado ✅', { restores });
  }

  // Arranca: guarda copia + vigila cambios en la página
  function boot() {
    backup();
    restoreIfMissing();

    const mo = new MutationObserver(() => {
      backup();
      restoreIfMissing();
    });

    mo.observe(document.documentElement, { subtree: true, childList: true });
  }

  // Ejecuta cuando el DOM está listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
